import { React, useState } from 'react'
import { IconButton, InputAdornment, TextField, Box } from '@mui/material'
import { createNewFolder } from '../../services/createNewFolder'
import AddIcon from '@mui/icons-material/Add'
import { useMutation } from '@tanstack/react-query'

const TextFieldCreateFolder = ({ onSubmit, listaDocs, folderId, idPratica }) => {
    const [disable, setDisable] = useState(true)
    const [textValue, setTextValue] = useState('')

    const { mutate: createNewFolderMutation } = useMutation({
        mutationFn: () => {
            return createNewFolder(folderId, textValue, idPratica)
        }, onSuccess: (data, variables, context) => {
            onSubmit()
            setTextValue('')
        }
    })

    const changeTextValue = value => {
        setTextValue(value)
        setDisable(value.trim() === '' || listaDocs.map(doc => doc.name).includes(value.trim()))
    }

    return (
        <Box
            component="form"
            onSubmit={event =>
                createNewFolderMutation(event, folderId, textValue.trim())
            }
            sx={{ width: '100%' }}
        >
            <TextField
                value={textValue}
                onChange={event => changeTextValue(event.target.value)}
                variant="standard"
                sx={{ width: '100%', mt: 1 }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                disabled={disable}
                                variant="contained"
                                onClick={event =>
                                    createNewFolderMutation(event, folderId, textValue.trim())
                                }
                            >
                                <AddIcon fontSize="medium"></AddIcon>
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            ></TextField>
        </Box>
    )
}

export default TextFieldCreateFolder
